import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  controls: {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
    paddingBottom: "24px",
    flexWrap: "wrap",
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      margin: "0px",
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    position: "relative",
    flexShrink: 0,
  },
  searchField: {
    flex: 1,
    minWidth: "120px",
    "@media (max-width: 900px)": {
      width: "100%",
      flex: "none",
    },
  },
  label: {
    display: "block",
    fontSize: "11px",
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    margin: "0px",
    lineHeight: "16px",
  },

  viewButton: {
    minWidth: "32px",
    minHeight: "32px",
    width: "32px",
    height: "32px",
    padding: "0px",
    "&.Mui-selected": {
      backgroundColor: capitalDesignTokens.semanticColors.background.actionMedium,
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: capitalDesignTokens.semanticColors.background.actionHeavy,
        color: "#FFFFFF",
      },
    },
  },
  srOnly: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0px",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0px",
  },
  accessSelectAll: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    paddingBottom: "8px",
    cursor: "pointer",
    color: capitalDesignTokens.semanticColors.foreground.action,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    fontSize: "14px",
  },
  accessItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "6px",
    paddingBottom: "6px",
  },
});
